import { numFormat } from '~/utils/globalMethods'
import { formatViews, formatNumber, formatCurrency } from '~/utils/format'

/**
 * globalMethods
 * @author wwl
 * @created 2024/10/27
 * @modified 2024/10/27
 */
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.provide('numFormat', numFormat)
  nuxtApp.provide('formatViews', formatViews)
  nuxtApp.provide('formatNumber', formatNumber)
  nuxtApp.provide('formatCurrency', formatCurrency)
})
